//
//
//
//
//
//
//
//

// 网络错误组件
export default {
  name: 'OutdatedkError',
  data: function data() {
    return {
      title: '项目过期组件'
    };
  },
  props: {},
  created: function created() {},
  destroyed: function destroyed() {},
  methods: {
    refresh: function refresh() {
      this.$emit('refreshEvent');
    }
  }
};